import { observer } from 'mobx-react-lite';
import { LoanApplicationDto } from 'src/generated-api-client';
import { AgentLoanApplicationFinalOffer } from 'src/pages/AgentLoanApplicationDetailsPage/components/AgentLoanApplicationFinalOffer';
import { AgentLoanApplicationGeneralInfo } from 'src/pages/AgentLoanApplicationDetailsPage/components/AgentLoanApplicationGeneralInfo';
import { AgentLoanApplicationInitialOffer } from 'src/pages/AgentLoanApplicationDetailsPage/components/AgentLoanApplicationInitialOffer';
import { AgentLoanApplicationPartnerInfo } from 'src/pages/AgentLoanApplicationDetailsPage/components/AgentLoanApplicationPartnerInfo';

type AgentLoanApplicationGeneralInfoTabProps = {
    application?: LoanApplicationDto;
};

export const AgentLoanApplicationGeneralInfoTab = observer(
    ({ application }: AgentLoanApplicationGeneralInfoTabProps) => {
        return (
            <>
                <AgentLoanApplicationGeneralInfo application={application} />
                <AgentLoanApplicationPartnerInfo application={application} />
                <AgentLoanApplicationInitialOffer application={application} />
                <AgentLoanApplicationFinalOffer application={application} />
            </>
        );
    },
);
